<template>
  <div class="content">
    <div class="main">

      <div class="container text-center">
        <h2>{{ title }}</h2>
      </div>

      <div class="container text-left">
        <p>Looking at the sound wave diagram then harmonics can be thought of as:<br />
          How many cycles does it take for two tonal frequencies to coinside in our ear at maximum air pressure?
          The fewer cycles the more harmonic.<br />
          Our brain perceives two tonal frequencies not related by a simple fraction as noise.</p>

        <h4>Fundamental Frequency Ratios</h4>

        <p>Higher in the list is more harmonic with the tonic.
          The numericator is how many times the tonic note frequency would cycle while
          the denominator is how many times the secondary note frequency would cycle until they coinside at maximum air pressure in your ear.
        </p>

        <table class="table table-bordered thead-dark">
          <tr>
            <th>Ratio</th>
            <th>Interval</th>
            <th>Diatonic Name</th>
            <th>Description</th>
          </tr>
          <tr>
            <td>1/1</td>
            <td>unison</td>
            <td>tonic</td>
            <td></td>
          </tr>
          <tr>
            <td>2/1</td>
            <td>octive</td>
            <td>tonic</td>
            <td></td>
          </tr>
          <tr>
            <td>3/2</td>
            <td>perfect 5th</td>
            <td>dominate</td>
            <td>halfway between octaves</td>
          </tr>
          <tr>
            <td>4/3</td>
            <td>4th</td>
            <td>subdominate</td>
            <td></td>
          </tr>
          <tr>
            <td>5/3</td>
            <td>Major 6th</td>
            <td>submediant</td>
            <td>halfway down to the subdominate</td>
          </tr>
          <tr>
            <td>5/4</td>
            <td>Major 3rd</td>
            <td>mediant</td>
            <td>*, halfway up to the dominate</td>
          </tr>

          <tr>
            <td>6/5</td>
            <td>Minor 3rd</td>
            <td>minor mediant</td>
            <td></td>
          </tr>
          <tr>
            <td>8/5</td>
            <td>Minor 6th</td>
            <td>minor submediant</td>
            <td></td>
          </tr>
          <tr>
            <td>9/5</td>
            <td>Minor 7th</td>
            <td>minor subtonic</td>
            <td></td>
          </tr>

          <tr>
            <td>9/8</td>
            <td>Major 2nd (9th)</td>
            <td>supertonic</td>
            <td></td>
          </tr>
          <tr>
            <td>15/8</td>
            <td>Major 7th</td>
            <td>leading tone</td>
            <td>*</td>
          </tr>
        </table>

        <p>* For chords formed with tonic and dominate the harmonics with the dominate need to be considered.
          Then notes with a denominator of a power of 2 are more harmonic being the major 3rd and major 7th.</p>

        <p>Notes that take above 5 cycles to coinside with the tonic start to become dissonate.</p>

        <p>Minor 2nd (25/24) and diminished 5th (45/32) notes are not considered harmonic
          because the numbers of cycles required for the frequencies to coinside
          is so long our brains will consider the relationship as noise.</p>

        <p>The ratios in this chart is represented by fractional frequency changes.
          The relationship between frequency change and string length is exponential not fractional.
          Which is why the scale 5th note is half way between octaves not the 4th.</p>

      </div>

      <div class="section text-center">
        <a href="https://pages.mtu.edu/~suits/scales.html" target="_blank">B. H. Suits' Physics of Music - Scales: Just vs Equal Temperament</a>
      </div>

    </div>
  </div>
</template>

<script>
import * as MusicData from '@/data/music_data'

export default {
  name: "Harmonics",
  components: {
  },
  data() {
    return {
      title: "Harmonics",
      rootKeys: MusicData.notes,
      chords: {
        rootKey: 'C'
      }
    };
  },
  mounted: function () {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
.h1 {
  font-family: "kingthings_organicaextra_bold", Impact, "Arial Black",
    sans-serif;
}
</style>
